// libs
import cx from 'classnames';
import React, { memo } from 'react';
// styles
import styles from './SummaryTable.module.scss';
const Cell = ({ children, className }) => {
    return React.createElement("span", { className: cx(styles.tableCell, className) }, children);
};
export default memo(Cell);
